module.exports = __webpack_public_path__ + "static/img/fangji.534e038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fangji.png
// module id = JooB
// module chunks = 1